import { createSlice } from '@reduxjs/toolkit'

export const youtubeReadySlice = createSlice({
  name: 'youtubeReady',
  initialState: false,
  reducers: {
    initYoutubeAPI: state => (state = true)
  }
})

export const { initYoutubeAPI } = youtubeReadySlice.actions

export default youtubeReadySlice.reducer
